import {LOGIN_FORM_CHANGE} from '../../constants';
import {withType} from '../../../utils/actionOperations';
export const loginFormChange = event => {
    return dispatch => {
        dispatch(withType(LOGIN_FORM_CHANGE, event));
    };
};
